<script>
    import { onMount } from "svelte";
    import { Section, Spinner } from "@/components";
    import { getPathParams } from "svelte-mini-router";
    import { getCalooPage } from "@/services/orbbyte";
    import _ from "lodash";
    import { chooseOrbbyteLang } from "@/utils/lang";
    import { app, trackEvent } from "@/services/firebase";
    import appStore from "@/utils/store";

    let data = $state(null);
    let loading = $state(true);

    onMount(async () => {
        const params = getPathParams();

        if (params.id && params.id !== "null") {
            data =
                (
                    await getCalooPage({
                        idPost: params.id,
                        language: chooseOrbbyteLang(),
                    })
                )?.data[0] || null;
            if (!data) {
                console.error("frame not found");
                return;
            }

            setImagesTo100Percent();
            loading = false;
        } else {
            data = {
                data: appStore.get("frameData").data,
                returnUrl: "dashboard",
                pageName: appStore.get("frameData").title || "Frame",
            };
            loading = false;
        }
        trackEvent("frame_loaded", {
            frameId: params?.id || "default",
        });
    });

    function setImagesTo100Percent() {
        _.delay(() => {
            document.querySelector("img")?.style.setProperty("width", "100%");
        }, 100);
    }
</script>

{#if loading}<Spinner text="" width="100%" height="100%" />{/if}
{#snippet section()}
    <div class="frame__content">
        {@html data?.data}
    </div>
{/snippet}

<Section
    headerText={data?.pageName || ""}
    returnBtn={true}
    actionBack={data?.returnUrl || "settings"}
    className="frame"
    {section}
/>

<style lang="scss">
    @use "./styles/index.scss";
</style>
